var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStartArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "MDI_arrow-left-thin-circle-outline",
    "data-name": "MDI / arrow-left-thin-circle-outline",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.612,
    height: 20.593,
    viewBox: "0 0 19.612 20.593",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 19.612,
    height: 20.593,
    transform: "translate(0 0)",
    fill: "#ec9140",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_arrow-left-thin-circle-outline",
    "data-name": "Path / arrow-left-thin-circle-outline",
    d: "M16.807,10.213a6.595,6.595,0,1,1-6.595-6.595,6.621,6.621,0,0,1,6.595,6.595m1.618,0a8.213,8.213,0,1,0-8.213,8.213,8.195,8.195,0,0,0,8.213-8.213m-6.948-.821V6.928l3.252,3.285L11.477,13.5V11.034H5.7V9.391",
    transform: "translate(-0.671 0.014)",
    fill: "#ec9140"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartArrow);
export default __webpack_public_path__ + "static/media/start-arrow.ffc8573f8a853e3cdcc8bd25453ce04c.svg";
export { ForwardRef as ReactComponent };